import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 89EC2121-104F-4814-849A-AF9AA744E239
 * name music-accidental-double-sharp
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-accidental-double-sharp.svg
 * tags
 * - Music 
 */
export const MusicAccidentalDoubleSharpIcon = createSvgIcon(<><path d="M15.41 10H17V7H14V8.59L12 10.59L10 8.59V7H7V10H8.59L10.59 12L8.59 14H7V17H10V15.41L12 13.41L14 15.41V17H17V14H15.41L13.41 12L15.41 10Z" /></>, 'MusicAccidentalDoubleSharpIcon');
export default MusicAccidentalDoubleSharpIcon